import { render } from "./KpiDocumentDesignerKpiSelectDialog.vue?vue&type=template&id=1c73806e&ts=true"
import script from "./KpiDocumentDesignerKpiSelectDialog.vue?vue&type=script&lang=ts"
export * from "./KpiDocumentDesignerKpiSelectDialog.vue?vue&type=script&lang=ts"

import "./KpiDocumentDesignerKpiSelectDialog.vue?vue&type=style&index=0&id=1c73806e&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__